import { render, staticRenderFns } from "./FormNewPass.vue?vue&type=template&id=d74ba8d2&scoped=true&"
import script from "./FormNewPass.vue?vue&type=script&lang=js&"
export * from "./FormNewPass.vue?vue&type=script&lang=js&"
import style0 from "./FormNewPass.vue?vue&type=style&index=0&id=d74ba8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74ba8d2",
  null
  
)

export default component.exports